import gql from 'graphql-tag'

export const main = gql`
	fragment cashRegisterMain on CashRegister {
		parameters {
			phone
			street
			city
			postCode
			companyName
			additionName
			vatNumber
			optional1
			optional2
			autoCloseBill
			advertisingText
			country
			language
			printer {
				autoPrintBills
				notPrintRFIDBills
				printBillFromAmount
			}
			loginMode
			loyaltyProdItemId
			loyaltyProdItemIdOp2
			loyaltyProdItemIdOp3
			loyaltyProdItemIdOp4
			loyaltyProdItemIdOp5
			employeeLoyaltyProductId
			smsNotificationPhoneNumbers
		}
	}
`

export const kasse = gql`
	fragment cashRegisterKasse on CashRegister {
		creditClientsId
		parameters {
			reducedVat
			normalVat
			specialVat
			isInCafeModeInt
			isInCafeMode
			isInCafeModeDefault
			noUseIsInCafePrice
			isActiveTimeAssist
			loginOnlyAfterTimeRecording
			logoutOnlyAfterTimeRecording
			apaleoPmsProperty
			pmsType
			pmsProtelIP
			pmsProtelPort
			nonGuestTransfer
			pmsAutoPrintBills
			creditCards {
				clientButtonName {
					value
					position
				}
				startPiecemeal {
					value
					position
				}
				isPiecemeal {
					value
					position
				}
				receiptCopies {
					value
					position
				}
			}
			discountForm {
				button1
				buttonName1
				button2
				buttonName2
				button3
				buttonName3
				button4
				buttonName4
				button5
				buttonName5
				buttonName6
				button6
				buttonName7
				button7
				buttonName8
				button8
				buttonName9
				button9
				buttonName10
				button10
			}
			isDiscountFormDisabled
			drawerCloseCheck
			hideCashBackBtn
			hideOpenDrawerBtn
			isDrawerOpenDuringClosing
			isReturnButtonDeleted
			printImmediateCancel
			enableYouthProtection
			designProject
			restaurantIsMainMode
			restaurantDefaultRoom
			restaurantBirdViewActive
			isHospitalityReceiptEnabled
			isInCafeConfirmationBeforePayment
			serviceCallMode
			retrieveNumberOfGuests
			closingType
			isEmployeeClosingActive
			correctionTo
			isSafeBagActive
			priceLevelForm {
				timeInterval {
					from
					to
				}
				priceLevel {
					normal
					inCafe
				}
				weekDays
			}
			isSellProductInWorkingTime
			foreignCurrency {
				euro {
					roundTo
					changeTo
					exchangeRateIsUsed
					additionPercent
					exchangeRateDate
					isEuroCoinsNotShown
					is200EuroNotShown
					isShowTotalEuroOnCustomerDisplay
					isActive
					isDefinedMannualy
				}
				w1 {
					currencyFrom
					currencyTo
					exchangeRate
					exchangeRateIsUsed
					exchangeRateDate
					additionPercent
					isDefinedMannualy
				}
				w2 {
					currencyFrom
					currencyTo
					exchangeRate
					exchangeRateIsUsed
					exchangeRateDate
					additionPercent
					isDefinedMannualy
				}
				w3 {
					currencyFrom
					currencyTo
					exchangeRate
					exchangeRateIsUsed
					exchangeRateDate
					additionPercent
					isDefinedMannualy
				}
			}
			itemLoyaltyCard
			activateTipFunction
			egumaCreditId
			isEgumaActive
			guradoCreditId
			isGuradoActive
			axessCreditId
			isAxessActive
			preoderPrepaidProduct
			preoderPickupProduct
			signature
			pentacodeDeviceId
		}
	}
`

export const hardware = gql`
	fragment cashRegisterHardware on CashRegister {
		installVersion
		shop {
			id
			kitchenMasterClientId
			gruberConfig {
				id
				name
				ip
				crId
				pooling
			}
		}
		parameters {
			printer {
				name
				ip
				labelTitle
				isPrintEFTReceipts
				connectionType
				printCartQR
				separateKitchenBill
				separateKitchenCourse
				topMargin
				defaultLabelID
				automaticLabelPrint
				labelOffset
				isKitchenPrinterActive
				isPrintKitchenBillAfterCompletionOnly
				isPrintKitchenBillForTableOnly
				printCoursePositions
				locations {
					position
					isActive
					ip
					isDirectConnected
					ipDeviceLabel
					copyForWaiter
					tableShiftReceipt
					roomIds
					kdsHardwareId
					gruberDispenserId
					type
					isAnnounce
					isPrintByMasterQueue
				}
				receiptPrintersConfiguration {
					type
					connectionTarget
					roomIds
				}
			}
			builtInFonts
			localIPAdress
			hasBarcodeByReceiptTotal
			paymentTerminal {
				id
				type
				serialNumber
				posId
				ip
				port
				creditPositionInfo {
					position
				}
				walleeApplicationKey
				walleeVirtualTerminalId
				walleeUserId
				walleeSpaceId
				walleeTerminalID
				adyenApiKey
				adyenLiveEndpointUrlPrefix
				adyenPoiId
				hsPayStore
			}
			gloryTerminalConnected
			gloryTerminalAddress
			gloryTerminalUser
			gloryTerminalPassword
			categoryFont{
				fontName
				size
			}
			productFont{
				fontName
				size
			}
			autoCloseBill
			autoSelectFirstCategory
			categoryGridX
			categoryGridY
			specialDesignType
			cardTextColor
			isMainScreenWithVideo
			accentColor
			textColor
			backgroundColor
			hasFastLine
			multiLanguage
			mainScreenLogo
			paymentBackgroundImg
			loyaltyCardImg
			loyaltyCardIcon
			takeOutImg
			inCafeImg
			settingsPassword
			showOrderViewKiosk
			useOldDesign
			logo {
				img {
					uid
					key
				}
			}
			disallowLoyaltyCards
			closingTime
			displayEitherCategoriesOrProducts
			idleMinutesBeforeLock
			displayArticle
			scale
			scaleDisplayAlwaysVisible
			isQRCodeBillEnabled
			weightTara {
				names {
					value
					position
				}
				values {
					value
					position
				}
				isAutoSelect {
					value
					position
				}
			}
			tseIsActive
			tseType
			tseAdminPin
			tseAdminPuk
			tseTimeAdminPin
			tseTimeAdminPuk
			tseEpsonIp
			tsePrintQRCode
			isCashierHasManyDrawers
			showPriceOnKitchenBill
			showPriceOnCreditCustomerBill
		}
		isSynced
		deviceIdentity {
			hardwareId
			clientType
			eloviewId
		}
		status
		tseRemoteCashRegisterId
		tseInfo {
			info
			expirationDate
      }
	}
`

export const general = gql`
	fragment cashRegisterGeneral on CashRegister {
		shopId
		name
		priceLevelIn
		priceLevelOut
		mode
		outOfOrder
		outOfOrderReason
		outOfOrderDate
	}
`

export const external = gql`
	fragment cashRegisterExternal on CashRegister {
		clientNumber
		externToolBox
		filial
	}
`

export const openingHours = gql`
	fragment openingHours on Shop {
		openingHours {
			id
			flag
			date
			timeSlot
			description
			day
			openingTime {
				from
				to
			}
			lunchBreak {
				from
				to
			}
		}
	}
`

export const accountingData = gql`
	fragment accountingData on Shop {
		clientNum
		costCentre
		passAccount
		cashRegisterAccount
		taxAccount
		taxAccountSorted
		taxCode
		taxCodeSorted
		compensateDayDifference
		noExportPassAccount
		credit
		outcome
		additionalCurrencies
		euroInCHF
		loyaltyCardRef
		loyaltyCardTopUp
		loyaltyCardDiscount
	}
`

